module.exports = __webpack_public_path__ + "images/points-with-lines.png";